export function prepareState(acc, current) {
      return {...acc, [current.id]: current}
}


// WEBPACK FOOTER //
// ./src/utils/prepareState.js